import React, { useState, useEffect, useContext, useCallback } from "react";
import { Tab } from "@mui/material";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import FieldText from "../../../../common/component/form/FieldText";
import FieldDate from "../../../../common/component/form/FieldDate";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import Slider from "../../../../common/component/slider/Slider";
import LayoutCreateOrder from "../../../../common/layout/LayoutCreateOrder";
import OrderMap from "./OrderMap";
import { path } from "../../../../constants/apiPath";
import { useNavigate } from "react-router-dom";
import { StoreContext } from "../../../../store";
import moment from "moment";
import instance from "../../../../common/api/interceptor";
import Schedule from "./schedule/Schedule";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import ScheduleTable from "./schedule/ScheduleTable";
import { NotificationManager } from "react-notifications";
import ModalOrderPlan from "../../../../constants/data/ModalOrderPlan";
import CancelPresentationRoundedIcon from "@mui/icons-material/CancelPresentationRounded";
import debounce from "lodash.debounce";
import { userRole } from "../../../../utils/utility";

function OrderPlan() {
  const context = useContext(StoreContext);
  const [directions, setDirections] = useState("D");
  const [valueSlider, setValueSlider] = useState(2);

  const [showSchedule, setShowSchedule] = useState(false);
  const [scheduleSelected, setScheduleSelected] = useState(false);
  const [scheduleSelectedData, setScheduleSelectedData] = useState([]);
  const navigate = useNavigate();

  //plan
  const [loading, setLoading] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [comLogo, setComLogo] = useState([]);
  const [compName, setCompName] = useState([]);
  const [lines, setLines] = useState([]);

  const [sendingOptions, setSendingOptions] = useState([{ OrgCode: "" }]);
  const [recivingOptions, setRecivingOptions] = useState([]);
  const [originPortInput, setOriginPortInput] = useState("");
  const [destinationPortInput, setDestinationPortInput] = useState("");
  const [carrierOptions, setCarrierOptions] = useState([]);

  const [orderPlanJson, setOrderPlanJson] = useState([]);

  const [mapCoordinates, setMapCoordinates] = useState([]);

  const forwarderOptions = [
    { value: "MTS", key: "0" },
    { key: "1", value: "Other" },
  ];

  useEffect(() => {
    context.setValue("1");
    // getAgentOrCarrier("ReceivingAgent");
    // getAgentOrCarrier("SendingAgent");
    getAgentOrCarrier("Carrier");
    const orderPlan = [...context.orderJSON.OrderPlanningCollection];
    setOrderPlanJson([...orderPlan]);
  }, []);

  useEffect(() => {}, []);

  const getAgentOrCarrier = (type) => {
    const url = `${path.AGENT_CARRIER}${type}&orgPk=`;
    instance
      .get(url)
      .then((res) => {
        console.log(type, res.data);
        // return res.data ?? [];
        if (type === "ReceivingAgent") {
          setRecivingOptions(res.data ?? []);
        } else if (type === "SendingAgent") {
          setSendingOptions(res.data ?? []);
        } else {
          setCarrierOptions(res.data ?? []);
        }
      })
      .catch(() => {
        return [];
      });
  };

  const getPorts = useCallback(
    debounce(async (country, port, type = "origin") => {
      
      instance
        .get(`${path.GET_UNLOCO}`, {
          params: {
            country: country,
            portcodeorname: port,
            transportMode: "", //context.orderJSON?.OrderHeader?.OrderTransportMode
          },
        })
        .then(async (res) => {
          console.log("portlist", res);
          if (type === "origin") {
            await context.setOriginPort([]);
            context.setOriginPort(res.data ?? []);
          } else {
            await context.setDestinationPort([]);
            context.setDestinationPort(res.data ?? []);
          }
        })
        .catch((err) => {
          console.log("error section", err);
          if (type === "origin") {
            context.setOriginPort([]);
          } else {
            context.setDestinationPort([]);
          }
        });
    }, 200),
    []
  );

  const onNextHandler = (path) => {
    const body = {
      ...context.orderJSON,
      OrderPlanningCollection: [...orderPlanJson],
      OrderNotesCollection: [],
    };
    context.setOrderJSON({
      ...body,
    });
    navigate(path, {
      state: { edit: true },
    });

    console.log("orderPlanJson", body);
  };

  // const onPostOrder = (route, body) => {
  //   // alert("api");
  //   instance
  //     .post(path.POST_ORDER, body)
  //     .then((res) => {
  //       navigate(route);
  //     })
  //     .catch((err) => {});
  // };

  const getScheduleCards = async (data) => {
    context.setBackDropOpen(true);
    const URL = `https://dashboard.mts-logistics.com/MTSConnectAPIServices/api/GetSearchResults?origin_code=${
      data?.PlanningOriginPortName?.Code ?? ""
    }&destination_code=${
      data?.PlanningDestinationPortName.Code ?? ""
    }&start_date=${
      data.PlanningCutOfDate
        ? moment(data.PlanningCutOfDate).format("DD-MM-YYYY")
        : moment().format("DD-MM-YYYY")
    }&weeks_ahead=${valueSlider}&direction_A_or_D=${directions}&sac_codes=${
      data.PlanningCarrierCode?.ShippingSacCode ?? ""
    }`;

    await axios
      .post(URL)
      .then((res) => {
        context.setBackDropOpen(false);
        if (res?.data?.shipping_lines?.length) {
          let logo = [];
          let data = [];
          let companyName = [];
          res.data.shipping_lines.forEach((element) => {
            logo.push(element.line_logo);
            companyName.push(element.line_name);
            let tempData = [];
            element.line.forEach((item) => {
              tempData.push(item);
            });
            data.push(tempData);
          });
          setComLogo(logo);
          setCompName(companyName);
          setLines(data);
          setSearchResult(res.data.shipping_lines);
        }
        setShowSchedule(true);
      })
      .catch((err) => {
        context.setBackDropOpen(false);
        NotificationManager.error("Something went wrong", "", 3000);
        console.error(err);
      });
  };

  const onRequestQuote = (item, comLogo, compName, cutoffdate, data) => {
    console.log(data);
    console.log(context.value);

    let depart = new Date(0);
    depart.setUTCSeconds(data.originDate);
    let arrival = new Date(0);
    arrival.setUTCSeconds(data.destinationDate);

    let cut = new Date(0);
    cut.setUTCSeconds(data.cutoffDate);

    const orderPlan = [...orderPlanJson];

    orderPlan[parseInt(context.value - 1)].PlanningVessel = data.vesselName;
    orderPlan[parseInt(context.value - 1)].PlanningVoyage = data.voyage;
    orderPlan[parseInt(context.value - 1)].PlanningCarrierCode = data.carrier;
    orderPlan[parseInt(context.value - 1)].PlanningEstimatedDepart = depart;
    orderPlan[parseInt(context.value - 1)].PlanningEstimatedArrival = arrival;
    orderPlan[parseInt(context.value - 1)].PlanningCutOfDate = cut;

    setShowSchedule(false);

    console.log({ orderPlan });
  };

  const onAddHandler = () => {
    const arr = [...orderPlanJson];
    // const map = [...mapCoordinates]
    arr.push({ ...ModalOrderPlan });

    context.setValue(arr.length.toString());
    setOrderPlanJson(arr);
  };

  const onChangeHandler = (lable, value, index) => {
    const arr = [...orderPlanJson];
    arr[index][lable] = value;
    setOrderPlanJson([...arr]);
  };

  const deletePlan = (event, ele, index) => {
    event.stopPropagation();
    const arr = [...orderPlanJson];
    arr.splice(index, 1);
    setOrderPlanJson([...arr]);
    context.setValue((prev) => {
      if (arr.length > 0) {
        if (parseInt(prev) === 1) {
          return "1";
        }
        if (parseInt(prev) > 1) {
          return (parseInt(prev) - 1).toString();
        }
      }
    });
  };

  return (
    <LayoutCreateOrder onNextHandler={onNextHandler} title="Create Order">
      <div className="_orderPlanComp">
        <TabContext value={context.value}>
          <TabList
            variant="scrollable"
            scrollButtons="auto"
            onChange={(event, newValue) => context.setValue(newValue)}
            className="_orderPlanTabs"
          >
            {orderPlanJson.map((ele, index) => {
              let num = index + 1;
              return (
                <Tab
                  label={
                    num < 10 ? (
                      <div className="_orderPlanTabsDiv">
                        Plan 0{num}
                        {index + 1 === parseInt(context.value) ? (
                          <button
                            onClick={(e) => {
                              deletePlan(e, ele, index);
                            }}
                          >
                            <CancelPresentationRoundedIcon />
                          </button>
                        ) : null}
                      </div>
                    ) : (
                      <div className="_orderPlanTabsDiv">
                        Plan {num}
                        {index + 1 === parseInt(context.value) ? (
                          <button
                            onClick={(e) => {
                              deletePlan(e, ele, index);
                            }}
                          >
                            <CancelPresentationRoundedIcon />
                          </button>
                        ) : null}
                      </div>
                    )
                  }
                  value={num.toString()}
                  key={num}
                />
              );
            })}
            {!showSchedule && (
              <div className="_addPlan">
                <div className="_solidButton">
                  <button
                    disabled={!context.orderUserAccess?.CreateOrderPlan}
                    onClick={() => {
                      onAddHandler();
                    }}
                  >
                    + Add Plan
                  </button>
                </div>
              </div>
            )}
          </TabList>
          {orderPlanJson.map((ele, index) => {
            let num = index + 1;
            return (
              <TabPanel
                value={num.toString()}
                index={num}
                className={`_orderPlanTabBody _orderPlanTabBody${ele}`}
                key={index}
              >
                <div className="container-fluid">
                  {scheduleSelected ? (
                    <ScheduleTable
                      setScheduleSelected={setScheduleSelected}
                      scheduleSelectedData={scheduleSelectedData}
                    />
                  ) : showSchedule ? (
                    <Schedule
                      loading={loading}
                      searchResult={searchResult}
                      comLogo={comLogo}
                      compName={compName}
                      lines={lines}
                      onRequestQuote={onRequestQuote}
                      setShowSchedule={setShowSchedule}
                      setScheduleSelected={setScheduleSelected}
                    />
                  ) : (
                    <div className="row">
                      <div className="col-lg-8 col-12 _orderPlan">
                        <div className="row">
                          <div className="col-md-5 col-12 _orderPlanPlace">
                            <div className="_orderTimelineDivParent">
                              <div className="_orderTimelineDiv">
                                <div className="_orderTimelineDotLine">
                                  <div className="_orderTimelineDot"></div>
                                  <div className="_orderTimelineLine" />
                                </div>
                                <div className="_orderTimelineInputs">
                                  <h6>Origin</h6>
                                  <div className={`width100`}>
                                    <Autocomplete
                                      disablePortal
                                      disableClearable={false}
                                      size="small"
                                      value={ele.PlanningOriginCountryName}
                                      onChange={(event, newValue) => {
                                        onChangeHandler(
                                          "PlanningOriginCountryName",
                                          newValue ?? { Description: "" },
                                          index
                                        );
                                        setOriginPortInput("");
                                        context.setOriginPort([]);
                                      }}
                                      options={
                                        context.defaultValue.originCountry ?? []
                                      }
                                      getOptionLabel={(option) =>
                                        option.Description
                                      }
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Country"
                                        />
                                      )}
                                    />
                                  </div>
                                  <div className={`width100`}>
                                    <Autocomplete
                                      disablePortal
                                      disableClearable={false}
                                      noOptionsText={
                                        ele.PlanningOriginCountryName?.Code
                                          ?.length
                                          ? originPortInput.length > 1
                                            ? "No options"
                                            : "Type for search"
                                          : "No options"
                                      }
                                      size="small"
                                      value={ele.PlanningOriginPortName}
                                      onInputChange={(e, newValue) => {
                                        setOriginPortInput(newValue);
                                        if (newValue.length > 1) {
                                          getPorts(
                                            ele.PlanningOriginCountryName.Code,
                                            newValue,
                                            "origin"
                                          );
                                        } else {
                                          context.setOriginPort([]);
                                        }
                                      }}
                                      // value={originPort}
                                      onChange={(event, newValue) => {
                                        onChangeHandler(
                                          "PlanningOriginPortName",
                                          newValue ?? { PortName: "" },
                                          index
                                        );
                                      }}
                                      options={context.originPort ?? []}
                                      getOptionLabel={(option) => {
                                        const title = option.PortName
                                          ? option.PortName +
                                            "(" +
                                            option.Code +
                                            ")"
                                          : "";
                                        return title;
                                      }}
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Port"
                                        />
                                      )}
                                    />
                                  </div>
                                  {/* <div className={`width100`}>
                                    <Autocomplete
                                      disablePortal
                                      disableClearable={false}
                                      size="small"
                                      value={ele.PlanningSendingAgentCode}
                                      onChange={(event, newValue) => {
                                        onChangeHandler(
                                          "PlanningSendingAgentCode",
                                          newValue ?? { OrgCode: "" },
                                          index
                                        );
                                      }}
                                      options={sendingOptions ?? []}
                                      getOptionLabel={(option) =>
                                        option.OrgCode
                                      }
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Sending Agent"
                                        />
                                      )}
                                    />
                                  </div> */}
                                </div>
                              </div>
                              <div className="_orderTimelineDiv">
                                <div className="_orderTimelineDotLine">
                                  <div className="_orderTimelineDot"></div>
                                </div>
                                <div className="_orderTimelineInputs">
                                  <h6>Destination</h6>
                                  <div className={`width100`}>
                                    <Autocomplete
                                      disablePortal
                                      disableClearable={false}
                                      ListboxProps={{
                                        style: {
                                          maxHeight: "12rem",
                                        },
                                      }}
                                      size="small"
                                      value={ele.PlanningDestinationCountryName}
                                      onChange={(event, newValue) => {
                                        onChangeHandler(
                                          "PlanningDestinationCountryName",
                                          newValue ?? { Description: "" },
                                          index
                                        );
                                        setDestinationPortInput("");
                                        context.setDestinationPort([]);
                                      }}
                                      options={
                                        context.defaultValue.originCountry ?? []
                                      }
                                      getOptionLabel={(option) =>
                                        option.Description
                                      }
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Country"
                                        />
                                      )}
                                    />
                                  </div>
                                  <div className={`width100`}>
                                    <Autocomplete
                                      disablePortal
                                      disableClearable={false}
                                      size="small"
                                      value={ele.PlanningDestinationPortName}
                                      noOptionsText={
                                        ele.PlanningDestinationCountryName?.Code
                                          ?.length
                                          ? destinationPortInput.length > 1
                                            ? "No options"
                                            : "Type for search"
                                          : "No options"
                                      }
                                      onInputChange={(e, newValue) => {
                                        setDestinationPortInput(newValue);
                                        if (newValue.length > 1) {
                                          getPorts(
                                            ele.PlanningDestinationCountryName
                                              .Code,
                                            newValue,
                                            "Destination"
                                          );
                                        }
                                        context.setDestinationPort([]);
                                      }}
                                      onChange={(event, newValue) => {
                                        onChangeHandler(
                                          "PlanningDestinationPortName",
                                          newValue ?? { PortName: "" },
                                          index
                                        );
                                      }}
                                      options={context.destinationPort ?? []}
                                      getOptionLabel={(option) => {
                                        const title = option.PortName
                                          ? option.PortName +
                                            "(" +
                                            option.Code +
                                            ")"
                                          : "";
                                        return title;
                                      }}
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Port"
                                        />
                                      )}
                                    />
                                  </div>

                                  {/* <div className={`width100`}>
                                    <Autocomplete
                                      disablePortal
                                      disableClearable={false}
                                      size="small"
                                      value={ele.PlanningReceivingAgentCode}
                                      onChange={(event, newValue) => {
                                        onChangeHandler(
                                          "PlanningReceivingAgentCode",
                                          newValue ?? { OrgCode: "" },
                                          index
                                        );
                                      }}
                                      options={recivingOptions ?? []}
                                      getOptionLabel={(option) =>
                                        option.OrgCode
                                      }
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Receiving Agent"
                                        />
                                      )}
                                    />
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-7 col-12 _orderContData">
                            {/* <h5>
                            Shipping date availibility &amp; Container number
                          </h5> */}
                            <div className="row _orderContDataInputs">
                              {context.orderJSON?.OrderHeader?.OrderTransportMode.includes(
                                "AIR"
                              ) ? null : (
                                <div className="col-sm-6 col-12">
                                  <FieldText
                                    label="Vessel"
                                    value={ele.PlanningVessel}
                                    onChange={(e) => {
                                      onChangeHandler(
                                        "PlanningVessel",
                                        e.target.value,
                                        index
                                      );
                                    }}
                                  />
                                </div>
                              )}
                              <div className="col-sm-6 col-12">
                                <FieldText
                                  label={
                                    context.orderJSON?.OrderHeader?.OrderTransportMode.includes(
                                      "AIR"
                                    )
                                      ? "Flight Number "
                                      : "Voyage Number"
                                  }
                                  value={ele.PlanningVoyage}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningVoyage",
                                      e.target.value,
                                      index
                                    );
                                  }}
                                />
                              </div>

                              <div className="col-sm-6 col-12">
                                <FieldDate
                                  label="Departure Date"
                                  value={ele.PlanningEstimatedDepart}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningEstimatedDepart",
                                      e,
                                      index
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-sm-6 col-12">
                                <FieldDate
                                  label="Arrival Date"
                                  value={ele.PlanningEstimatedArrival}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningEstimatedArrival",
                                      e,
                                      index
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-sm-6 col-12">
                                <FieldDate
                                  label="Cut Off Date"
                                  value={ele.PlanningCutOfDate}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningCutOfDate",
                                      e,
                                      index
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-sm-6 col-12">
                                <div className={`width100`}>
                                  <Autocomplete
                                    disablePortal
                                    disableClearable={false}
                                    size="small"
                                    value={ele.PlanningCarrierCode}
                                    onChange={(event, newValue) => {
                                      onChangeHandler(
                                        "PlanningCarrierCode",
                                        newValue ?? { OrgCode: "" },
                                        index
                                      );
                                    }}
                                    options={carrierOptions ?? []}
                                    getOptionLabel={(option) => option.OrgCode}
                                    sx={{ width: 300 }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label={
                                          context.orderJSON?.OrderHeader?.OrderTransportMode.includes(
                                            "AIR"
                                          )
                                            ? "Airline"
                                            : "Carrier"
                                        }
                                      />
                                    )}
                                  />
                                </div>
                              </div>

                              <div className="col-sm-6 col-12">
                                {/* <FieldDate
                                  label="Cut Off Date"
                                  value={ele.PlanningCutOfDate}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningCutOfDate",
                                      e,
                                      index
                                    );
                                  }}
                                /> */}
                                <div className={`width100`}>
                                  <Autocomplete
                                    disablePortal
                                    disableClearable={false}
                                    size="small"
                                    value={ele.PlanningForwarderCarrier}
                                    onChange={(event, newValue) => {
                                      onChangeHandler(
                                        "PlanningForwarderCarrier",
                                        newValue ?? { value: "" },
                                        index
                                      );
                                    }}
                                    options={forwarderOptions ?? []}
                                    getOptionLabel={(option) => option.value}
                                    sx={{ width: 300 }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Forwarder/Carrier"
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              {context.orderUserAccess?.ViewRates ? (
                                <div className="col-sm-6 col-12">
                                  {ele.PlanningForwarderCarrier.value ===
                                  "MTS" ? (
                                    <TextField
                                      disabled={
                                        !context.orderUserAccess?.ViewRates
                                      }
                                      label="Rates"
                                      type="number"
                                      pattern="[0-9]*"
                                      size="small"
                                      value={ele.PlanningRates}
                                      onChange={(e) => {
                                        if (parseInt(e.target.value) < 0) {
                                          onChangeHandler(
                                            "PlanningRates",
                                            Math.abs(parseInt(e.target.value)),
                                            index
                                          );
                                        } else {
                                          onChangeHandler(
                                            "PlanningRates",
                                            e.target.value,
                                            index
                                          );
                                        }
                                      }}
                                    />
                                  ) : null}
                                </div>
                              ) : null}
                            </div>

                            <div className="row _orderContRadio">
                              <div className="col-12">
                                <FormControl component="fieldset">
                                  <FormLabel component="legend">
                                    Available Directions
                                  </FormLabel>
                                  <RadioGroup
                                    row
                                    value={directions}
                                    onChange={(e) =>
                                      setDirections(e.target.value)
                                    }
                                  >
                                    <FormControlLabel
                                      value="D"
                                      control={<Radio />}
                                      label="Earlier Departure Date"
                                    />
                                    <FormControlLabel
                                      value="A"
                                      control={<Radio />}
                                      label="Latest Arrival Date"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </div>
                            </div>
                            <div className="row _orderContSlider">
                              <div className="col-8">
                                <div>{valueSlider} Weeks</div>
                                <Slider
                                  valueSlider={valueSlider}
                                  setValueSlider={setValueSlider}
                                />
                              </div>
                              <div className="col-4">
                                <div className="_solidButton">
                                  <button onClick={() => getScheduleCards(ele)}>
                                    FIND
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-12 _orderPlanMap">
                        <OrderMap
                          mapCoordinates={mapCoordinates ?? []}
                          originCoor={ele.PlanningOriginPortName}
                          destinationCoor={ele.PlanningDestinationPortName}
                          loading={false}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </TabPanel>
            );
          })}
        </TabContext>
      </div>
    </LayoutCreateOrder>
  );
}

export default OrderPlan;
